import { useEffect } from 'react'
import styled from 'styled-components'
import WhatRewards from './whatrewards'
import WayToSpendWins from './waytospendwins'
import HowToJoin from './howtojoin'
import Tutorial from './tutorial'
import { useTranslation } from 'react-i18next'
import { adobePageViewEvent, adobeInteractionEvent } from 'utils/adobewa'

const SpendWINSPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: #e6dfd7;
`

const PageTilteText = styled.div`
    color: #121b21;
    text-align: center;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 60px; /* 125% */
    padding-top: 32px;
    padding-bottom: 24px;
`

export default function SpendWins() {
    const { i18n, t } = useTranslation('', {
        keyPrefix: 'spendwins.spendwins',
    })

    const lang = i18n.language

    useEffect(() => {
        adobePageViewEvent(lang)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        const handleScroll = () => {
            // Calculate current scroll position and window height
            const scrollY = window.pageYOffset
            const windowHeight = window.innerHeight

            // Calculate document height
            const documentHeight = Math.max(
                document.body.scrollHeight,
                document.documentElement.scrollHeight,
                document.body.offsetHeight,
                document.documentElement.offsetHeight,
                document.documentElement.clientHeight
            )

            // Check if the user has scrolled to the bottom (or very close)
            // A small threshold can be added to account for potential rounding issues
            const threshold = 5 // Pixels from the bottom to consider "at bottom"
            if (scrollY + windowHeight >= documentHeight - threshold) {
                adobeInteractionEvent({
                    lang: lang,
                    eventID: `prioritysite_Scroll_Page_Bottom`,
                })

                window.removeEventListener('scroll', handleScroll)
            }
        }

        // Add scroll event listener
        window.addEventListener('scroll', handleScroll)

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <SpendWINSPageContainer>
            <PageTilteText>{t(`pageTitle`)}</PageTilteText>
            <WhatRewards />
            <WayToSpendWins />
            <Tutorial />
            <HowToJoin />
        </SpendWINSPageContainer>
    )
}
